import BookingWidgetModal from './BookingWidgetModal'

export default BookingWidgetModal
